// @flow
import React from 'react';
import { connect } from 'react-redux';

import styles from './booleanCell.css';
import toggleStyles from '../../../ToggleSwitch/toggleSwitch.css';

// TODO: prop disableCondition()
export type BooleanCellPropTypes = {
  value: string | number,
  trueLabel?: string | React$Node,
  falseLabel?: string | React$Node,
  editable?: boolean,
  onChange?: Function,
  original: Object,
  disabled?: boolean,
};

type SwitchStateTypes = {
  value: boolean | string | number
}

class Boolean extends React.Component<BooleanCellPropTypes, SwitchStateTypes> {
  constructor(props: BooleanCellPropTypes) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  _onClick() {
    const { value } = this.state;
    const { onChange, original } = this.props;
    this.setState({
      value: !value,
    });
    if (onChange) {
      onChange(original, !value);
    }
  }

  render() {
    const {
      editable = false,
      trueLabel = 'Si',
      falseLabel = 'No',
      disabled = false,
    } = this.props;
    const { value } = this.state;
    if (editable) {
      return (
        <div className={`
        ${toggleStyles.toggleSwitchContainer}
        ${toggleStyles.medium} 
        ${toggleStyles.left} 
      `}>
          <div
            role="switch"
            tabIndex={0}
            onClick={this._onClick.bind(this)}
            className={disabled ? `${toggleStyles.toggleSwitch} ${toggleStyles.disabled}` : toggleStyles.toggleSwitch}
            onKeyDown={() => {}}
          >
            <div className={value ? toggleStyles.check : ''} />
            <span className={toggleStyles.slider} />
          </div>
          <div className={toggleStyles.toggleText}>{value ? trueLabel : falseLabel}</div>

        </div>
      );
    }

    return (
      <span className={styles.boolean}>
        { value ? trueLabel : falseLabel }
      </span>
    );
  }
}

export default connect(
  (state, { original, disableCondition }) => ({
    disabled: disableCondition ? disableCondition(original) : false,
  }),
  undefined,
)(Boolean);



// WEBPACK FOOTER //
// ./src/scripts/components/DataTable/Cells/Boolean/index.jsx